import { ApiNamespaces, IQueuedRequest, OneAPIOptions } from '../../common'
import { AppOrdersApi } from './app'
import { BackofficeOrdersApi } from './backoffice'
import { Queue } from '../../queue'

export class Orders implements ApiNamespaces {
  app: AppOrdersApi
  backoffice: BackofficeOrdersApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new AppOrdersApi(name, sessionId, requestsQueue, options)
    this.backoffice = new BackofficeOrdersApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.app.invalidateAll()
    this.backoffice.invalidateAll()
  }
}
